/**
 * The glyphs that point along the line of text, and so MIRROR in a right-to-left layout (RTL-ready UI, the
 * user 2026-10-09; Material's rule: back, forward and side-pointing arrows mirror, everything else does not).
 * `Icon` flips these itself when its subtree is `rtl`, so no caller branches on the direction. A search
 * magnifier, a close cross, a pin or an up/down chevron is the same in every language and is not listed.
 * `icons.test.ts` holds every name here to the registry.
 */
import type { IconName } from "@rista/ui/library/components/Icon";

export const MIRRORED_IN_RTL: ReadonlySet<IconName> = new Set<IconName>(["arrowBack", "chevronLeft", "chevronRight", "back-icon", "right-arrow-icon-blue"]);
